import { render } from "./SectionEditor.vue?vue&type=template&id=4c18b33f"
import script from "./SectionEditor.vue?vue&type=script&lang=js"
export * from "./SectionEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__